import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[replace-smart-punctuation]'
})
export class ReplaceSmartPunctuationDirective {
  @HostListener('input', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    let trimmed = input.value.replace(/[\u2018\u2019\u201C\u201D]/g,(c) => '\'\'""'.substr('\u2018\u2019\u201C\u201D'.indexOf(c), 1));
    input.value = trimmed;
  }
}
